import { type AppContext } from '../GlobalExecutionContext';

// The browser cannot read EXECUTION_CONTEXT, so the SPA needs a static copy of the hostnames
// that serve no single Portal. The server keeps deriving its own list from
// EXECUTION_CONTEXT.PORTAL_URL and enforces the host on the API independently.
export const DEFAULT_PORTAL_HOSTNAMES_STATIC: readonly string[] = [
  'portal.willowservicing.com',
  'staging-portal.willowservicing.co',
  'flex-portal.willowservicing.co',
  'portal.servicingsystem.com',
  'portal.servicingsystem.co',
  'portal.flex.servicingsystem.co',
];

// Kept out of deployed environments because the portal API skips company scoping on a default
// host, and the host it reads for that is client-supplied.
const LOCAL_DEFAULT_PORTAL_HOSTNAMES: readonly string[] = ['portal.servicingsystem.localhost', 'localhost'];

export const defaultPortalHostnamesFor = (appContext: AppContext): readonly string[] =>
  appContext === 'development' || appContext === 'test'
    ? [...DEFAULT_PORTAL_HOSTNAMES_STATIC, ...LOCAL_DEFAULT_PORTAL_HOSTNAMES]
    : DEFAULT_PORTAL_HOSTNAMES_STATIC;

export const isDefaultPortalHostnameStatic = (hostname: string, appContext: AppContext): boolean =>
  defaultPortalHostnamesFor(appContext).includes(hostname.trim().toLowerCase().replace(/\.$/, ''));
